import { useEffect, useMemo } from 'react'

import { COLOUR_BLIND_PALETTE } from '@avcan/constants/products/forecast/ratings/colors'

import * as Sources from './sources/context'
import { useUserSettings } from 'contexts/usersettings'
import { useMap } from 'contexts/map'

// TODO: This is WET with `<Layers.ForecastAreas on={onLayerEvents} id={productId} />`, but that approach was causing a lot of issues (mousemove taking too long, map polygons not updating, click handlers broken). This code is not great with some nasty useEffects, but it is so far the only way that works for the desired archive functionality, stepping through time and having click handlers work on the correct layers.
export const ArchiveForecastAreas = ({ on }) => {
    const source = 'forecasts'
    const areas = Sources.useForecastAreas()
    const metadata = Sources.useForecastMetadata()
    const map = useMap()
    const { colourblindModeEnabled } = useUserSettings()

    // Inject metadata into each area's properties so that we can use them on the map
    const data = useMemo(() => {
        return {
            ...areas,
            features: areas?.features.map(area => {
                const specificMetaData = metadata.find(product => product.area.id === area.id)
                const { value } = specificMetaData.highestDanger
                const colour = colourblindModeEnabled
                    ? COLOUR_BLIND_PALETTE.get(value)
                    : specificMetaData.highestDanger.colour

                return {
                    ...area,
                    properties: {
                        ...area.properties,
                        colour,
                        id: specificMetaData.product.id,
                        highestDanger: value,
                    },
                }
            }),
        }
    }, [areas, colourblindModeEnabled, metadata])

    // Add sources and layers
    useEffect(() => {
        if (!map.getSource(source) && data?.features) {
            map.addSource(source, { type: 'geojson', data, promoteId: 'id' })
        }
        if (!map.getLayer(source) && map.getSource(source)) {
            map.addLayer({
                id: source,
                source,
                type: 'fill',
                paint: {
                    'fill-color': ['get', 'colour'],
                    'fill-opacity': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        0.7,
                        0.5,
                    ],
                },
            })
        }
        if (!map.getLayer(source + '-line') && map.getSource(source)) {
            map.addLayer({
                id: source + '-line',
                source,
                type: 'line',
                paint: {
                    'line-color': 'black',
                    'line-width': ['case', ['boolean', ['feature-state', 'hover'], false], 3, 1],
                },
            })
        }
        if (map) {
            map.on('click', source, on)
        }

        return () => {
            if (map) {
                map.off('click', source, on)
            }
            try {
                // HACK: The below lines are needed to permit subsequent clicks on the map, though they throw an error on unmmount (cannot read property 'removeLayer' of undefined) despite the above conditional
                if (map.getLayer(source)) {
                    map.removeLayer(source)
                }
                if (map.getLayer(source + '-line')) {
                    map.removeLayer(source + '-line')
                }
                if (map.getSource(source)) {
                    map.removeSource(source)
                }
            } catch (error) {}
        }
    }, [data, map, on])

    return null
}
